import React, {useEffect, useState} from "react";
import {Button, Grid, Tab, Tabs, Typography, Dialog, Container, DialogContent, DialogActions} from "@mui/material";
import { Grid as DataGrid, GridColumn } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import AddIcon from "@mui/icons-material/Add";
import { Input } from "@progress/kendo-react-inputs";
import DeleteIcon from "@mui/icons-material/Delete";
import {CurrencyCell} from "../currency-cell";
import { PercentageCellOneHundredStocksBondsCash } from "../percentage-cell";
import { getCurrentYear, currencyFormatNoDecimals, collectErrorMessages } from "../../shared/shared";
import FrequencyDropDown from "../frequency-dropdown";
import InfoIcon from "@mui/icons-material/Info";
import {
  TaxTypeDropDownCell,
  AccountTypeDropDownCell,
} from "../account-tax-type-cells";
import YearCell from "../year-cell";
import { MAX_CURRENCY } from "../../shared/constants";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import IconButton from "@mui/material/IconButton";
import ErrorIcon from "@mui/icons-material/Error";
import {StyledTooltip} from "../../pages/plan-inputs";
import ValidationSignCell from "../validation-sign-cell";
import OwnerJointTrustDropDown from "../owner-joint-trust-cell";
import ContributionSourceErrorCell from "../contribution-source-error-cell";
import ContributionSourceTypeDropDown from "../contribution-source-type-dropdown";
import InsurancePolicies from "../insurance-policies";
import TrustNameDialog from "../trust-name-dialog";

const AdditionalInformation = (props) => {
  const [state, setState] = useState({
    value: 0
  });

  useEffect(() => {
      if (Array.isArray(props.policies) && props.policies.length === 0) {
        addPolicy();
      }
  }, []);

  const handleChangeTabs = (event, newValue) => {
    setState((v) => ({ ...v, value: newValue }));
  };

  const close = (e) => {
    if (validateInsurancePolicies(props.policies))
      props.save();
  }

  const handleChange = (valueChange, idQuestion, valueAnswers) => {
    AdditionalInformation.updateAdditional({
      answer: valueChange.target.value,
      clientQuestionId: valueAnswers === undefined ? null : valueAnswers.clientQuestionId,
      questionId: idQuestion,
      editIndex: valueAnswers === undefined ? null : valueAnswers.editIndex
    })
  }

  const updatePolicy = (field) => {
    return (dataItem, value) => {
      const newPolicies = props.policies.map(item => {
        if(item.editIndex === dataItem.editIndex) {
          item[field] = value;
        }
        return item;
      });
      props.updatePolicies(newPolicies);
    };
  };

  const addPolicy = () => {

    if (props.policies.length >= 10) return;

    const newEditIndex = Math.max(
        ...props.policies.map((item) => item.editIndex)
    );
    const newPolicy = {
      id: null,
      policyOwner: "",
      policyType: "",
      deathBenefitAmount: "",
      premium: "",
      cashValue: "",
      editIndex: props.policies.length > 0 ? newEditIndex + 1 : 0,
      inEdit: true
    };
    props.updatePolicies([...props.policies, newPolicy]);
  };

  const deletePolicy = async (dataItem) => {
    const updatedPolicies = props.policies.filter(item => item.editIndex !== dataItem.editIndex);
    props.updatePolicies(updatedPolicies);
  }


  function validateInsurancePolicies(policies) {

    const MAX_CHARACTERS = 50;

    return policies.every(policy => {
      for (let key in policy) {
        if (key === "id" || key === "editIndex") continue;
        if (typeof policy[key] === 'string' && policy[key].length > MAX_CHARACTERS) {
          return false;
        }
      }

      return true;
    });
  }


  return (
    <Container>
      <Grid item xs={12}>
        <Typography component={"h1"}>Savings And Contributions Additional Information</Typography>
      </Grid>
      <Tabs value={state.value} onChange={handleChangeTabs} aria-label="basic tabs example">
        <Tab label="Assets" />
        <Tab label="Life insurance" />
        <Tab label="ltc/disability insurance inputs" />
      </Tabs>
      <Grid container>
        {state.value === 0 && (
          <Grid container spacing={3} mt={2}>
            {props.questionsAssets.map(e => {
              const valueAnswers = props.answers.find((answer) => answer?.questionId === e.id)
              return (
                <Grid key={e.id} item xs={12}>
                  <Input
                    onChange={(valueChange) => { handleChange(valueChange, e.id, valueAnswers) }}
                    value={valueAnswers?.answer}
                    label={e.question} />
                </Grid>)
            })}
          </Grid>
        )}
        {state.value === 1 && (
          <Grid container spacing={3} mt={2}>
            {props.questionsLifeInsurance.map(e => {
              const valueAnswers = props.answers.find((answer) => answer?.questionId === e.id)
              return (
                <Grid key={e.id} item xs={12}>
                  <Input
                    onChange={(valueChange) => { handleChange(valueChange, e.id, valueAnswers) }}
                    value={valueAnswers?.answer}
                    label={e.question} />
                </Grid>)
            })}
            <Grid item xs={12}>
              <InsurancePolicies policies={props.policies} update={updatePolicy} addPolicy={addPolicy} deletePolicy={deletePolicy} />
            </Grid>
          </Grid>
        )}
        {state.value === 2 && (
          <Grid container spacing={3} mt={2}>
            {props.questionsLtc.map(e => {
              const valueAnswers = props.answers.find((answer) => answer?.questionId === e.id)
              return (
                <Grid key={e.id} item xs={12}>
                  <Input
                    onChange={(valueChange) => { handleChange(valueChange, e.id, valueAnswers) }}
                    value={valueAnswers?.answer}
                    label={e.question} />
                </Grid>)
            })}
          </Grid>
        )}
      </Grid>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '30px 0' }}>
        <Button m={'0'} onClick={close}>close</Button>
      </div>
    </Container >
  );
};

const CommandCell = (addContribution, deleteAccount) => {
  return (props) => {
    const { dataItem } = props;

    if (!dataItem.inEdit) {
      return <td></td>
    }

    return (
      <td className={"command-buttons"}>
        <DeleteIcon
          onClick={() => {
            deleteAccount(dataItem);
          }}
        />
      </td>
    );
  };
};

const CurrencyCellAmount = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value,
      });
    }
  };

  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];

  if (!dataItem.inEdit) {
    return <td>
      {currencyFormatNoDecimals(dataValue)}
    </td>
  }

  return (
    <td >
      <NumericTextBox
        label={" "}
        value={dataValue}
        onChange={handleChange}
        format={"c0"}
        min={0}
        max={MAX_CURRENCY}
      />
    </td>
  );
};

const Contribution = (props) => {
  console.log(props.dataItem);
  const data = [props.dataItem.contributions];

  const transformedData = data.map(item => {
    item.inEdit = props.dataItem.inEdit;
    return item;
  });

  return (
    <DataGrid
      data={transformedData}
      scrollable={"none"}
      editField={"inEdit"}
      onItemChange={(event) => {
        Contribution.updateAccountContribution(props.dataItem)(event.field)(event);
      }}
    >
      <GridColumn title={" "} field={"isValid"} cell={ContributionSourceErrorCell} />
      <GridColumn field={"frequency"} title={"Frequency"} cell={FrequencyDropDown}/>
      <GridColumn field={"contributionSourceType"} title={"Source"} cell={ContributionSourceTypeDropDown} />
      <GridColumn field={"amount"} title={"Contribution Amount"} cell={CurrencyCellAmount} />
      <GridColumn field={"startYear"} title={"Start Year"} cell={YearCell} />
      <GridColumn field={"endYear"} title={"End Year"} cell={YearCell} />
    </DataGrid>
  );
};

const SavingsAndContributions = (props) => {
  const [state, setState] = useState({
    sort: [
      {
        field: "firstName",
        dir: "asc",
      },
    ],
    page: { skip: 0, take: 10 },
    showAdditionalInformationModal: false,
    errorMessages: [],
  });
  const [open, setOpen] = useState({
    dataItem: null,
    show: false,
    label: null,
  });
  const [trustDialogParams, setTrustDialogParams] = useState({
    isOpen: false,
    dataItem: null
  });

  useEffect(() => {
    setState({
      ...state,
      errorMessages: collectErrorMessages(props.validations.accounts, "account"),
    })
  }, [props.validations.accounts]);

  const validateContribution = (contributionSourceType, startYear, endYear) => {
    if (contributionSourceType === 'OUTSIDE_SOURCE')
      return true;

    let isValid = false;
    if (props.incomes) {
      props.incomes.forEach(income => {
        if (income.startYear <= startYear && income.endYear >= endYear) {
          isValid = true;
        }
      });
    }
    return isValid;
  };

  const addAccount = () => {
    const prototype = {
      accountType: "BROKERAGE",
      bonds: 0,
      cash: 0,
      contributions: {
        amount: 0,
        endYear: getCurrentYear(),
        frequency: "YEARLY",
        id: null,
        startYear: getCurrentYear(),
        editIndex: 0,
        inEdit: true,
        invalidFields: [],
        contributionSourceType: 'OUTSIDE_SOURCE',
        isValid: validateContribution('OUTSIDE_SOURCE', getCurrentYear(), getCurrentYear())
      },
      costBasis: 0,
      id: null,
      name: "Brokerage",
      stocks: 0,
      taxType: "NON-QUALIFIED",
      value: 0,
      owner: "CLIENT",
      editIndex: 0,
      isExpanded: false,
      inEdit: true,
      invalidFields: [],
    };

    props.addAccount(prototype);
  };

  const onExpandChange = (event) => {
    props.update("isExpanded")(event.dataItem, !event.dataItem.isExpanded);
  };

  const deleteFn = (dataItem) => {
    props.delete(dataItem);
  };

  const saveAdditionalInfo = () => {
    setState({
      ...state,
      showAdditionalInformationModal: false,
    });
  };

  const handleOtherDialogCancel = () => {
    setOpen({
      ...open,
      show: false,
    })
  }

  const handleOtherDialogSave = () => {
    props.update("accountTypeOtherName")(open.dataItem, open.label);
    setOpen({
      dataItem: null,
      show: false,
      label: null,
    });
  }

  // !stub
  const addContributionFn = (dataItem) => { };

  const openAddTrustDialog = (dataItem) => {
    setTrustDialogParams({
      isOpen: true,
      dataItem: dataItem
    });
  };

  Contribution.updateAccountContribution = props.updateAccountContribution;
  AdditionalInformation.updateAdditional = props.updateAdditional;
  AccountTypeDropDownCell.update = props.update;
  OwnerJointTrustDropDown.hasSpouse = props.client.hasSpouse;

  const accounts = props.accounts.map((item, index) => {
    const validation = props.validations.accounts[index];
    let isValid = true;
    if (validation) {
      Object.keys(validation).forEach((key) => {
        if (key === "contributions") {
          Object.keys(validation[key]).forEach((contributionKey) => {
            if (!validation[key][contributionKey].valid) isValid = false;
          });
        } else {
          if (!validation[key].valid) isValid = false;
        }
      });
    }

    return {
      ...item,
      showJointTrustOptions: item.taxType === "NON-QUALIFIED",
      inEdit: props.readOnly ? false : true,
      isValid: isValid,
      contributions: {
        ...item.contributions,
        isValid: validateContribution(item.contributions.contributionSourceType, item.contributions.startYear, item.contributions.endYear),
      },
    };
  });

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} display={'flex'} alignItems={'center'}>
        <Typography component={"h1"}>Savings and Contributions</Typography>
        <InfoIcon
          style={{ paddingLeft: '10px' }}
          onClick={() => {
            setState({
              ...state,
              showAdditionalInformationModal: true,
            });
          }}
        />

      </Grid>
      <Grid item xs={12}>
        {(!props.readOnly && state.errorMessages.length > 0) && (
            <div className="error-tooltip-wrapper">
              <StyledTooltip
                  arrow
                  className="error-tooltip"
                  placement="right"
                  title={
                    <ul className="error-tooltip-ul">{
                      state.errorMessages.map((e, idx) => {
                        return (
                            <li key={idx}>
                              <Typography
                                  className={'default-font'}
                                  textAlign={'left'}
                                  variant={'span'}> {e}
                              </Typography>
                            </li>
                        );
                      })}
                    </ul>
                  }
              >
                <IconButton>
                  <ErrorIcon />
                </IconButton>
              </StyledTooltip>
            </div>
        )}
        {!props.readOnly && <Button onClick={addAccount}>
          <AddIcon />
          Add Account
        </Button>}
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          data={orderBy(accounts, state.sort).slice(
            state.page.skip,
            state.page.take + state.page.skip
          )}
          skip={state.page.skip}
          take={state.page.take}
          total={props.accounts.length}
          pageable={true}
          onPageChange={(event) => {
            setState({
              ...state,
              page: event.page,
            });
          }}
          scrollable={"none"}
          expandField={"isExpanded"}
          onExpandChange={onExpandChange}
          detail={Contribution}
          editField={"inEdit"}
          onItemChange={(event) => {
            const dataItem = event.dataItem;
            const field = event.field;
            const value = event.value;
            if (field === 'accountType' && value === 'TE_OTHER') {
              setOpen({
                ...open,
                dataItem: dataItem,
                show: true,
                label: dataItem.accountTypeOtherName,
              });
            }
            props.update(field)(dataItem, value);
          }}
        >
          <GridColumn title={" "} field={"isValid"} cell={ValidationSignCell} />
          <GridColumn
            field={"taxType"}
            title={"Tax Type"}
            cell={TaxTypeDropDownCell}
          />
          <GridColumn
            field={"accountType"}
            title={"Account Type"}
            cell={AccountTypeDropDownCell}
          />
          <GridColumn title={"Owner"} field={"owner"} cell={(p) => <OwnerJointTrustDropDown {...p} openAddTrustDialog={openAddTrustDialog} allowNewTrusts={true} />} />
          <GridColumn
            field={"value"}
            title={"Acct Value"}
            cell={CurrencyCell}

          />
          <GridColumn
            field={"costBasis"}
            title={"Cost Basis"}
            cell={CurrencyCell}
          />
          <GridColumn field={"stocks"} title={"Stocks"} cell={PercentageCellOneHundredStocksBondsCash} />
          <GridColumn field={"bonds"} title={"Bonds"} cell={PercentageCellOneHundredStocksBondsCash} />
          <GridColumn field={"cash"} title={"Cash"} cell={PercentageCellOneHundredStocksBondsCash} />
          {!props.readOnly && <GridColumn
            title={" "}
            cell={CommandCell(addContributionFn, deleteFn)}
          />}
        </DataGrid>

        <TrustNameDialog
          open={trustDialogParams.isOpen}
          dataItem={trustDialogParams.dataItem}
          handleSave={(dataItem, name) => {

            props.update("owner")(dataItem, name);

            setTrustDialogParams({
              isOpen: false,
              dataItem: null
            });
          }}
          handleLeave={() => {
            setTrustDialogParams({
              isOpen: false,
              dataItem: null
            });
          }}
        />

        {state.showAdditionalInformationModal && (
          <Dialog
            fullWidth={true}
            maxWidth={"lg"}

            open={state.showAdditionalInformationModal}
            onClose={() => {
              setState({
                ...state,
                showAdditionalInformationModal: false,
              });
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <AdditionalInformation
              save={saveAdditionalInfo}
              questionsLtc={props.questionsLtc}
              questionsAssets={props.questionsAssets}
              questionsLifeInsurance={props.questionsLifeInsurance}
              answers={props.answers}
              policies={props.policies}
              updatePolicies={props.updatePolicies}
            />
          </Dialog>
        )}
        {open.show && (
            <Dialog
                fullWidth={true}
                maxWidth={"sm"}
                open={open.show}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
              <DialogContent style={{ margin: "auto" }}>
                <Input
                    label={"Custom Label"}
                    maxLength={25}
                    value={open.label}
                    onChange={(e) => {
                      setOpen({
                        ...open,
                        label: e.target.value,
                      })
                    }}
                />
              </DialogContent>
              <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
                <Button onClick={handleOtherDialogCancel}>
                  Cancel
                </Button>
                <Button onClick={handleOtherDialogSave}>
                  Save
                </Button>
              </DialogActions>
            </Dialog>
        )}
      </Grid>
    </Grid>
  );
};

export default SavingsAndContributions;
